import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  appType: sessionStorage.getItem("Apptype") || "Business",
  otpResponce: { otp: "", mobileNo: "" },
  loginid: "",
  sideBarToggle: false,
  actIndex: 0,
};
const uiSlice = createSlice({
  name: "uiSlice", // name of the slice
  initialState: initialState, // initial state of the slice
  reducers: {
    setSelectedProject: (state, action) => {
      state.selectedProject = action.payload;
    },

    setOTPResponce: (state, action) => {
      state.otpResponce = action.payload;
    },
    setLoginid: (state, action) => {
      state.loginid = action.payload;
    },
    updateAppType: (state, action) => {
      state.appType = action.payload;
      sessionStorage.setItem("Apptype", action.payload);
    },

    setSideBarToggle: (state, action) => {
      state.sideBarToggle = !state.sideBarToggle;
    },

    setActIndex: (state, action) => {
      state.actIndex = action.payload;
    },
  },
});
export const uiAction = uiSlice.actions;

export default uiSlice.reducer;
